// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";
import { Loader2, Mail, Lock, User, X } from "lucide-react";

export default function Register() {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Le mot de passe doit contenir au moins 6 caractères");
      return;
    }
    setLoading(true);
    try {
      await register(email, password, name);
      toast.success("Bienvenue sur Sen Cagnotte !");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur d'inscription");
    } finally {
      setLoading(false);
    }
  };

  const googleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12" data-testid="register-page">
      <div className="w-full max-w-md">
        <div className="card-soft p-8 sm:p-10 relative">
          <button
            type="button"
            onClick={() => navigate("/")}
            className="absolute top-4 right-4 h-9 w-9 rounded-full hover:bg-secondary flex items-center justify-center text-muted-foreground hover:text-foreground transition"
            aria-label="Fermer"
            data-testid="register-close"
          >
            <X className="h-5 w-5" />
          </button>
          <div className="flex justify-center mb-6">
            <img
              src="https://customer-assets.emergentagent.com/job_fundcollect-1/artifacts/z3sp2s14_logo-sen-cagnotte-1.png"
              alt="Sen Cagnotte"
              className="h-16 w-16 rounded-2xl object-cover shadow-lg"
            />
          </div>
          <h1 className="font-display text-3xl font-bold text-center mb-2">Créer un compte</h1>
          <p className="text-center text-muted-foreground mb-8 text-sm">Rejoignez Sen Cagnotte en 30 secondes</p>

          <Button
            type="button"
            variant="outline"
            className="w-full rounded-full h-11 mb-6 border-2"
            onClick={googleLogin}
            data-testid="google-register-btn"
          >
            <svg className="h-5 w-5 mr-2" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
            S'inscrire avec Google
          </Button>

          <div className="relative mb-6">
            <div className="absolute inset-0 flex items-center"><span className="w-full border-t" /></div>
            <div className="relative flex justify-center text-xs uppercase"><span className="bg-card px-2 text-muted-foreground">ou</span></div>
          </div>

          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="name">Nom complet</Label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <Input id="name" type="text" required value={name} onChange={(e) => setName(e.target.value)} className="pl-10 h-11 rounded-xl" placeholder="Aïssatou Diop" data-testid="register-name" />
              </div>
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="email">Email</Label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="pl-10 h-11 rounded-xl" placeholder="vous@exemple.com" data-testid="register-email" />
              </div>
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Mot de passe</Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="pl-10 h-11 rounded-xl" placeholder="6 caractères minimum" data-testid="register-password" />
              </div>
            </div>
            <Button type="submit" disabled={loading} className="w-full btn-gradient rounded-full h-11 font-medium" data-testid="register-submit">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Créer mon compte"}
            </Button>
          </form>

          <p className="text-center text-sm text-muted-foreground mt-6">
            Déjà un compte ?{" "}
            <Link to="/login" className="font-semibold text-foreground hover:gradient-text" data-testid="link-to-login">
              Se connecter
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
